import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entry", "filter", "toggleButton", "details"]
  static values = { expanded: Boolean }

  filter() {
    const query = this.filterTarget.value.toLowerCase().trim()
    this.entryTargets.forEach(entry => {
      const message = (entry.dataset.message || "").toLowerCase()
      entry.hidden = query !== "" && !message.includes(query)
    })
  }

  toggleAll() {
    this.expandedValue = !this.expandedValue
    const open = this.expandedValue
    this.detailsTargets.forEach(d => { d.open = open })
    this.toggleButtonTarget.textContent = open ? "折叠详情" : "展开详情"
  }
}
